import { Injectable } from '@angular/core';


import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import { GetTasks, getTasksLength } from '../../state-management';
import { Problem } from '../../models/problem';
import { of } from 'rxjs';

@Injectable()
export class MyTasksGuard  {
  constructor(private store: Store<{}>) {
  }

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore() {

    return this.store.select(getTasksLength)
      .pipe(
        tap(() => {
          this.store.dispatch(new GetTasks());
        }),
        take(1)
      );
  }
}
